import { useEffect } from 'react';
import { desktopBridge } from '../bridge';
import { isDesktopCallWindow } from '../callWindow';

/**
 * THE WINDOW BUTTONS FOLLOW THE THEME.
 *
 * The shell draws minimise/maximise/close over the top bar on a transparent
 * background, so only their glyph colour is left to choose - dark on a light
 * bar, light on a dark one. `ThemeProvider` states the theme as the `dark`
 * class on <html>, so that class is what is watched: any path that changes the
 * theme is covered without each of them knowing the shell exists.
 */
export function useDesktopTitleBar(): void {
  useEffect(() => {
    const setTheme = desktopBridge()?.setTitleBarTheme;
    /* A shell that can recolour the buttons is one that hid its native bar -
       and only the MAIN window does; a call window keeps its frame. */
    if (setTheme === undefined || isDesktopCallWindow()) return undefined;
    const root = document.documentElement;
    root.classList.add('desktop-caption');
    let last: boolean | null = null;
    const sync = (): void => {
      const dark = root.classList.contains('dark');
      if (dark === last) return;
      last = dark;
      void setTheme(dark).catch(() => undefined);
    };
    sync();
    const observer = new MutationObserver(sync);
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    return () => {
      observer.disconnect();
      root.classList.remove('desktop-caption');
    };
  }, []);
}
